<div id="manageannuities" class="subBlockContainer" [ngClass]="{'wgs-subscription-page':wgsSubscriptionPage}">
    <div class="subBlockContent" id="manageannuitiesId">

        <child-header *ngIf="programType ==='CSP'"
            [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()"
            [showAddUser]="true" titleAddUser="Create New End User" (addUserEvent)="addNewEndUser()"
            [showAssociate]="true" titleAssociate="Associate Existing End User" (associateEvent)="associateExistingEndUser()"            
            [showUpload]="true" titleUpload="Bulk Associate" (uploadEvent)="openBulkAssociatePopup()" 
            [showBulkTransfer]="true" titleBulkTransfer="Bulk Transfer" (uploadEventBulkTransfer)="openBulkTransferPopup()"
            [showUploadBulkOrder]="true" titleUploadBulkOrder="Bulk Order Creation" (uploadEventBulkOrder)="openBulkOrdersPopup()"
            [showDDAI]="ddaiService?.DDAICookie != null"
            [title]="programName" (closeEvent)="close()">          
        </child-header>   
        
        <child-header *ngIf="programType ==='KASP'"
            [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()"
            [showAddUser]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess" titleAddUser="Create New End User" (addUserEvent)="addKaspNewEndUser()"
            [title]="programName" (closeEvent)="close()">
        </child-header>

        <child-header *ngIf="programType ==='VDC'"
            [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()"
            [showAddUser]="true" titleAddUser="Create New End User" (addUserEvent)="addCirrusNewEndUser()"
            [title]="programName" (closeEvent)="close()">
        </child-header>

        <child-header *ngIf="programType ==='WGS'" titleAddUser="Create Contractor" [title]="programName"
            (closeEvent)="close()"></child-header>

        <child-header *ngIf="programType ==='AMP'"
            [title]="programName" (closeEvent)="close()"
            [showDownload]="false" titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()"
            [showEdit]="true" titleEdit="Manage Reseller Account" (editEvent)="editAMPReseller()"
            [showAddUser]="true" titleAddUser="Create New Customer" (addUserEvent)="addAMPNewEndUser()"
            [showAssociate]="true" titleAssociate="Change Reseller" (associateEvent)="associateAdobeCustomer()"
            [showMigrate]="true" titleMigrate="Migrate From VIP" (migrateEvent)="migrateVIPAMP()" 
            [showBulkMigrate]="true" titleBulkMigrate="Bulk Migrate From VIP" (bulkMigrateEvent)="bulkMigrateVIPAMP()"   
        ></child-header>

        <child-header *ngIf="programType !=='KASP' && programType  !=='CSP' && programType  !=='WGS' && programType  !=='AMP' && programType !=='VDC'" 
            [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()"
            [title]="programName" (closeEvent)="close()"></child-header>

        <div #ParentWrapper class="child-body">
            <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
            </loading-screen>
            <loading-screen *ngIf="!finishLoading"></loading-screen>
            <div *ngIf="loadContent" class="inner-subBlock-wrapper">
                <div class="page-title-wrapper">
                    <div class="row">
                        <div class="col-md-10 page-title-description">
                            <p>{{ longDescription }}</p>&nbsp;
                            <p *ngIf="moreInfo">
                                <a href="{{moreInfo}}" target="_blank">MoreInfo</a>
                            </p>
                        </div>
                        <div class="col-md-2 small-logo">
                            <a *ngIf="moreInfo" href="{{moreInfo}}" target="_blank">
                                <img [src]="logoURL"
                                    [class.adjust-logo-size]="programType === 'CISCO' || programType === 'CISCOSAAS'" />
                            </a>

                            <img *ngIf="!moreInfo" [src]="logoURL"
                                [class.adjust-logo-size]="programType === 'CISCO' || programType === 'CISCOSAAS'" />
                        </div>
                    </div>
                </div>
                <div class="top-divider"></div>
            </div>
            <div class="inner-subBlock-wrapper subs-wrapper" *ngIf="loadContent">

                <!-- AMP special code checking tenant table -->
                <ng-container *ngIf="programType == 'AMP'">
                    <label class="tenant-info-title">INDICATIVE PRICING</label>
                    <table  mat-table matSort [dataSource]="AMPCodeCheckingDataSource">
                        <ng-container matColumnDef="customerName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="endUserName" style="width: 841px; "> CUSTOMER </th>
                            <td mat-cell *matCellDef="let annuity" style="width: 841px;"> {{annuity?.companyName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="manage">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let annuity" class="center-button">
                                <button class="button button-red button-round"
                                    (click)="manageRedirect(annuity, model.detailsView)">
                                    &nbsp;Manage&nbsp;
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: AMPCodeCheckingTableColumns;"></tr>
                    </table>
                </ng-container>

                <!-- filter row -->

                <div class="row filter-wrapper" *ngIf="programType != 'WGS'" style="margin: 20px 0px ! important;">

                    <div class="searchInputGroup push-left" style="margin: 20px 20px ! important;">
                        <div class="searchIcon">
                            <img src="../../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                            onblur="this.placeholder='Filter'" [(ngModel)]="searchField"
                            (ngModelChange)="onMatChange()">
                    </div>

                    <div class="migrate-all-button" *ngIf="showAllMigrationButton() && programType === 'CSP'">
                        <button 
                            [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                            matTooltip="Requires Purchasing Permissions"
                            class="button button-red button-round" (click)="openNCEMigrationPopup()">
                            &nbsp;Migrate All Tenants To NCE&nbsp;
                        </button>
                    </div>

                    <div *ngIf="programType === 'AMP'">
                        <ng-select class="customDropdwon"  [items]="tenantExpiryOptionList" bindValue="value"
                            bindLabel="name" placeholder="Filter" [(ngModel)]="filterExpiryModel"
                            (change)="filterExpiry($event)" [clearable]="false">
                        </ng-select>
                    </div>

                </div>



                <ng-container *ngIf="!hasEmptyFilterResult">
                    <label class="tenant-info-title" *ngIf="programType == 'AMP'">YOUR CUSTOMERS</label>
                    <table *ngIf="['CSP', 'KASP', 'AMP','VDC'].includes(programType)"
                        mat-table matSort 
                        [dataSource]="dataSource" (matSortChange)="matSortData($event)" matSortDisableClear>
                        <ng-container matColumnDef="hasPaymentSetup">
                            <th class="col-1" mat-header-cell *matHeaderCellDef></th>
                            <td class="col-1" mat-cell *matCellDef="let annuity">
                                <span class="small-logo-wrapper" *ngIf="annuity?.hasPaymentSetup">
                                    <img src="../images/site-icons/my-account/digital-wallet.svg"
                                        ngbTooltip="Digital Wallet ID: {{annuity?.customerPaymentNumber}}"
                                        tooltipClass="tooltip-inner" placement="right"></span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="annuityId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="annuityId"> TENANT ID </th>
                            <td mat-cell *matCellDef="let annuity"> {{annuity?.annuityId}} </td>
                        </ng-container>
                        <ng-container matColumnDef="columnName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="endUserName"> {{firstColumnName}}
                            </th>
                            <td mat-cell *matCellDef="let annuity"> {{annuity?.endUserName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="anniversaryDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="anniversaryDate"> ANNIVERSARY DATE
                            </th>
                            <td mat-cell *matCellDef="let annuity" class="align-center">
                                <span *ngIf="showAnniversaryDate(annuity)">{{annuity?.anniversaryDate}}</span>   
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="autoRenew">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="autoRenewal"
                                style="
                                    height: 45px;
                                    display: grid;
                                    border-bottom-width: unset;
                                    border-bottom-style: unset;
                                ">
                                AUTO-RENEW
                            </th>
                            <td mat-cell *matCellDef="let annuity" class="align-center">
                                <img *ngIf="annuity?.autoRenew == 'YES'" src="../../images/site-icons/yes.svg" class="yes-no-icon-size">
                                <!-- <img *ngIf="annuity?.autoRenew == 'NO'" src="../../images/site-icons/no.svg" class="yes-no-icon-size"> -->
                                <span *ngIf="annuity?.autoRenew == 'NO'"></span>
                                <span *ngIf="annuity?.autoRenew != 'YES' && annuity?.autoRenew != 'NO'">
                                    {{annuity?.autoRenew}} 
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="openRenewal">
                            <th mat-header-cell *matHeaderCellDef class="table-cell" mat-sort-header="openRenewal"
                                style="text-align: center; white-space: nowrap;">
                                OPEN RENEWAL
                            </th>
                            <td mat-cell *matCellDef="let annuity" class="align-center">
                                <img *ngIf="isAnnuityOpenRenewal(annuity)" src="../../images/site-icons/yes.svg" class="yes-no-icon-size">
                                <span *ngIf="!isAnnuityOpenRenewal(annuity)"></span>
                                <!-- <img *ngIf="!isAnnuityOpenRenewal(annuity)"src="../../images/site-icons/no.svg" class="yes-no-icon-size"> -->
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="pendingTransactions">
                            <th mat-header-cell *matHeaderCellDef class="table-cell" mat-sort-header="pendingTransactions"
                                style="text-align: center; white-space: nowrap;">
                                PENDING TRANSACTIONS
                            </th>
                            <td mat-cell *matCellDef="let annuity" class="align-center">
                                <img *ngIf="annuity?.isAMPPendingTransaction" src="../../images/site-icons/yes.svg" class="yes-no-icon-size">
                                <span *ngIf="!annuity?.isAMPPendingTransaction"></span>
                                <!-- <img *ngIf="annuity?.pendingTransactions == 'NO'" src="../../images/site-icons/no.svg" class="yes-no-icon-size"> -->
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="currCustomerRef">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="currCustomerRef"> CUSTOMER REF </th>
                            <td mat-cell *matCellDef="let annuity"> {{annuity?.currCustomerRef}} </td>
                        </ng-container>
                        <ng-container matColumnDef="billingDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="billingDate"> NEXT BILL </th>
                            <td mat-cell *matCellDef="let annuity"> {{annuity?.billingDate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="totalAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="totalAmount"> AMOUNT(Ex) </th>
                            <td mat-cell *matCellDef="let annuity" class="align-right" style="padding-right: 50px;">
                                {{annuity?.totalAmount | currency:'AUD':'symbol-narrow':'.2-2'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="CSPtotalAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="totalAmount"> AMOUNT(Ex)<span
                                    [ngbTooltip]="'Azure charges are not included'">*</span> </th>
                            <td mat-cell *matCellDef="let annuity" class="col-2 align-right"
                                style="padding-right: 82px;">
                                <mat-progress-bar [color]="'accent'" [mode]="'indeterminate'"
                                    *ngIf="!annuity?.priceLoadingStatus">
                                </mat-progress-bar>
                                <span *ngIf="annuity?.priceLoadingStatus">{{annuity?.totalAmount |
                                    currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="euPortalAccess">
                            <th mat-header-cell *matHeaderCellDef> EU Portal Access </th>
                            <td mat-cell *matCellDef="let annuity" class="align-center"> 
                                <img *ngIf="annuity?.euPortalAccess" src="../../images/site-icons/yes.svg" class="yes-no-icon-size">
                                <span *ngIf="!annuity?.euPortalAccess"></span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="status"> STATUS </th>
                            <td mat-cell *matCellDef="let annuity" class="align-left"> {{annuity?.status}} </td>
                        </ng-container>
                        <ng-container matColumnDef="lastBillingDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="lastBillingDate">
                                Last Billing Date
                            </th>
                            <td mat-cell *matCellDef="let annuity"> {{annuity?.lastBillingDate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="manage">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let annuity" class="center-button">
                                <button class="button button-red button-round"
                                    (click)="manageRedirect(annuity, model.detailsView)">
                                    &nbsp;Manage&nbsp;
                                </button>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="migrate">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let annuity" class="center-button">
                                <button
                                    *ngIf="annuity?.containsLegacy == 'Y'"
                                    [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                                    [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                                    matTooltip="Requires Purchasing Permissions"
                                    class="button button-red button-round"
                                    (click)="openNCEMigrationPopup(annuity)"
                                >
                                    &nbsp;Migrate To NCE&nbsp;
                                </button>
                                <button
                                    *ngIf="(annuity?.migrationInProgress || annuity?.migrationCompleted) && annuity?.showMigrationReport"
                                    class="button button-red button-round" (click)="exportNCEMigrationReport(annuity)">
                                    &nbsp;NCE Migration Report&nbsp;
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <table *ngIf="annuities?.length && !['CSP', 'KASP', 'WGS', 'AMP','VDC'].includes(programType)"
                        matSort
                        class="white spla-table"
                        (matSortChange)="sortData($event)"
                    >
                        <thead>
                            <tr class="row">
                                <th class="col-1"></th>
                                <th class="col-2" mat-sort-header="endUserName"
                                [hidden]="programType ==='SKBAK' || programType === 'SKPLAT'" style="padding-left: 15px !important;">
                                    {{firstColumnName}}
                                </th>
                                <th mat-sort-header="currCustomerRef"
                                    [hidden]="programType ==='ADM' || programType ==='ADY'" class="col-3">CUSTOMER REF
                                </th>
                                <th mat-sort-header="lastBillingDate" [hidden]="programType !=='INTA'"
                                    class="align-right col" style="max-width: 13%">LAST BILL</th>
                                <th mat-sort-header="lastBillingAmount" [hidden]="programType !=='INTA'"
                                    class="align-right col" style="max-width: 12%">LAST AMOUNT(Ex)</th>
                                    <th mat-sort-header="billingDate" [hidden]="programType ==='INTA'"
                                    class="align-left col" style="max-width: 15%;white-space: nowrap">{{nextBillColumnName}}</th>
                                 <th mat-sort-header="totalAmount" [hidden]="programType ==='INTA'"
                                 *ngIf= " !(programType == 'SKBAK' || programType == 'SKPLAT')" class="align-right col" style="max-width: 12%">{{amountColumnName}} </th>
                                <th mat-sort-header="totalAmount" *ngIf= "programType ==='SKBAK' || programType === 'SKPLAT'"
                                        class="align-right col"  style="max-width: 18%;
                                        padding-right: 0px !important;white-space: nowrap;">{{amountColumnName}}</th>
                                <th mat-sort-header="status" [hidden]="programType ==='SKBAK' || programType ==='SKPLAT' " class="align-right col" style="max-width: 14%;">STATUS</th>
                                <th class="col" style="max-width: 9%"></th>
                                <th class="col" *ngIf= "programType ==='SKBAK' || programType === 'SKPLAT'" style="max-width: 9%;right: -40px;">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container>
                                <ng-container
                                    *ngFor="let annuity of sortedData | TableFilterMultiple:['endUserName', 'currCustomerRef', 'billingDate', 'totalAmount', 'status'] : searchField"
                                    #enduserTable>
                                    <tr class="row">
                                        <td class="col-1 align-right"> <span class="small-logo-wrapper"
                                                *ngIf="annuity?.hasPaymentSetup">
                                                <img src="../images/site-icons/my-account/digital-wallet.svg"  
                                                ngbTooltip="Digital Wallet ID: {{annuity?.customerPaymentNumber}}"
                                                tooltipClass="tooltip-inner" placement="top">
                                            </span></td>
                                        <td class="manage-text col-2"
                                            *ngIf="programType ==='SPLA' || programType ==='CITRIXCSP'"
                                            style="padding-left: 15px !important;">{{annuity?.vendorAgreementNo}}</td>
                                        <td class="manage-text col-2" [hidden]="programType ==='SKBAK' || programType === 'SKPLAT'"
                                            *ngIf="programType !='SPLA' && programType !='CITRIXCSP'"
                                            style="padding-left: 15px !important;">{{annuity?.endUserName}}</td>
                                        <td class="col-3" [hidden]="programType ==='ADM' || programType ==='ADY'">
                                            {{annuity?.currCustomerRef}}
                                        </td>
                                        <td class="align-left col" [hidden]="programType !=='INTA'"
                                            style="max-width: 13%">
                                            {{annuity?.lastBillingDate}}</td>
                                        <td class="align-right col" [hidden]="programType !=='INTA'"
                                            style="max-width: 12%; padding-right: 35px !important;">
                                            {{annuity?.lastBillingAmount | currency:'AUD':'symbol-narrow':'.2-2'}}
                                        </td>
                                        <td class="align-left col" [hidden]="programType ==='INTA'" *ngIf= " !(programType == 'SKBAK' || programType == 'SKPLAT') "
                                            style="max-width: 13%">
                                            {{annuity?.billingDate}}</td>                                        
                                        <td class="align-left col" *ngIf="programType == 'SKBAK' || programType == 'SKPLAT'"
                                            style="max-width: 13%">
                                            {{annuity?.nextOrderNo}}</td>
                                        <td class="align-right col" *ngIf="programType == 'CSP'"
                                            style="max-width: 15%; padding-right: 35px !important;">
                                            <mat-progress-bar [color]="'accent'" [mode]="'indeterminate'"
                                                *ngIf="!annuity?.priceLoadingStatus">
                                            </mat-progress-bar>
                                            <span *ngIf="annuity?.priceLoadingStatus">{{annuity?.totalAmount |
                                                currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                        </td>
                                        <td class="align-right col" *ngIf = "!(programType == 'CSP' || programType == 'SKBAK' || programType =='SKPLAT')"
                                            [hidden]="programType ==='INTA'"
                                            style="max-width: 15%; padding-right: 35px !important;">
                                            {{annuity?.totalAmount | currency:'AUD':'symbol-narrow':'.2-2'}}
                                        </td>
                                        <td class="align-right col" *ngIf = "programType == 'SKBAK' || programType =='SKPLAT'"                                       
                                        style="max-width: 18%;padding-right: 0px !important">
                                        {{annuity?.totalAmount | currency:'AUD':'symbol-narrow':'.2-2'}}
                                        </td>
                                        <td class="align-left col" [hidden]="programType ==='SKBAK' || programType === 'SKPLAT'" style="max-width: 14%">{{annuity?.status}}</td>
                                        <td class="col"  *ngIf= " !(programType == 'SKBAK' || programType == 'SKPLAT')" style="max-width: 9%;">
                                            <button class="button button-red button-mid"
                                                (click)="manageRedirect(annuity, model.detailsView)">Manage</button>
                                        </td>                                       
                                        <td class="col" *ngIf= "programType ==='SKBAK' || programType === 'SKPLAT'" style="max-width: 9%;right: -40px;">
                                            <button class="button button-red button-mid"
                                                (click)="manageRedirect(annuity, model.detailsView)">Manage</button>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>

                    <!-- wgs special sub page -->
                    <mat-accordion multi *ngIf="programType == 'WGS'">
                        <!-- PARTNER DETAILS -->
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="highlight-text"> PARTNER DETAILS </mat-panel-title>
                                <mat-panel-description class="panel-subtitle">
                                    <span class="highlight-text"> PARTNER NAME:&nbsp; </span><span>{{ WGSdetails?.customer?.out_company_name }}</span>
                                    <span class="highlight-text"> | PARTNER  ID:&nbsp; </span><span>{{ WGSdetails?.customer?.out_tenant_id }}</span>
                                    <!-- <span class="highlight-text"> | STATUS:&nbsp; </span><span>{{ WGSdetails?.customer?.out_status_desc }}</span> -->
                                    <mat-spinner *ngIf="isSubscriptionResponseLoading" diameter="20" mode="indeterminate" class="circle cSPCustomerEntitlements-loading"></mat-spinner>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                    
                            <dd-wgs-end-user-details
                                [details]="WGSdetails?.customer"
                                [isSubscriptionResponseLoading]="isSubscriptionResponseLoading"
                            ></dd-wgs-end-user-details>
                        </mat-expansion-panel>
                        <!-- HARDWARE SUBSCRIPTIONS -->
                        <mat-expansion-panel [expanded]="!isWGSItemLoading">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="highlight-text"> HARDWARE SUBSCRIPTIONS </mat-panel-title>
                                <mat-panel-description class="panel-subtitle">
                                    <span class="highlight-text"> {{ WGSHardwareSubs?.length ?
                                        WGSHardwareSubs.length : "0" }} Subscription(s) </span>
                                    <mat-spinner *ngIf="isWGSItemLoading" mode="indeterminate"
                                        class="circle cSPCustomerEntitlements-loading" diameter="20">
                                    </mat-spinner>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="searchInputGroup push-left" style="margin-left: 5px">
                                <div class="searchIcon">
                                    <img src="../../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter"
                                    onfocus="this.placeholder=''" onblur="this.placeholder='Filter'"
                                    [(ngModel)]="WGSHardwareSubSearchField" (ngModelChange)="filterWGSHardwareSubs()">
                            </div>
                            <div class="mTable">
                                <div *ngIf="WGSHardwareSubs?.length">
                                    <table class="table" mat-table [dataSource]="WGSHardwareSubs"
                                        style="margin-bottom: unset;">
                                        <!-- Desc Column -->
                                        <ng-container matColumnDef="desc">
                                            <th mat-header-cell *matHeaderCellDef width="50%" class="table-cell" style="text-align: left;">
                                                SUBSCRIPTION </th>
                                            <td class="push-left-75 table-cell" mat-cell *matCellDef="let sub">
                                                <span>PART CODE:&nbsp;</span>
                                                <span class="red-bold">{{ sub?.subscriptionListView?.out_stock_code}}</span>

                                                <div class="result-info">
                                                    <div class="produc-secondary-title-wrapper">
                                                        <span class="description">{{sub?.subscriptionListView?.out_stk_description}}</span>
                                                        <div class="result-info">
                                                            <span>SUBSCRIPTION ID:&nbsp;</span>
                                                            <span class="red-bold">{{sub?.subscriptionListView?.out_subscription_id}}&nbsp;&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>

                                        <!-- UserCount Column -->
                                        <ng-container matColumnDef="userCount">
                                            <th mat-header-cell *matHeaderCellDef class="align-center table-cell"
                                                width="15%"> QTY </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-center align-top table-cell">
                                                <span *ngIf="sub?.subscriptionDetailView"> {{
                                                    sub?.subscriptionDetailView?.userCount }} </span>
                                            </td>
                                        </ng-container>

                                        <!-- Status Column -->
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef class="align-center table-cell"
                                                width="15%"> STATUS </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-center align-top table-cell">
                                                <span *ngIf="sub?.subscriptionDetailView"> {{
                                                    sub?.subscriptionDetailView?.subscriptionStatus }} </span>
                                            </td>
                                        </ng-container>

                                        <!-- RRP Column -->
                                        <ng-container matColumnDef="rrp">
                                            <th
                                                *matHeaderCellDef
                                                mat-header-cell
                                                class="align-right table-cell"
                                                width="10%"
                                            >
                                                <span>RRP</span> 
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let sub;"
                                                class="align-right push-left-75 table-cell"
                                            >
                                                <span>{{ sub?.subscriptionListView?.out_rrp | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</span>
                                            </td>
                                        </ng-container>

                                        <!-- Price Column -->
                                        <ng-container matColumnDef="price">
                                            <th mat-header-cell *matHeaderCellDef class="align-right table-cell"
                                                width="10%"> PRICE </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-right push-left-75 table-cell">
                                                {{ sub?.subscriptionListView?.out_price |
                                                currency:'AUD':'symbol-narrow':'.2-2'}}
                                                <span>/mth</span>
                                            </td>
                                        </ng-container>

                                        <!-- Total Column -->
                                        <ng-container matColumnDef="total">
                                            <th mat-header-cell *matHeaderCellDef class="align-right table-cell"
                                                width="10%"> TOTAL </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-right push-left-75 table-cell">
                                                {{ sub?.subscriptionListView?.out_amount |
                                                currency:'AUD':'symbol-narrow':'.2-2'}}
                                                <span>/mth</span>
                                            </td>
                                        </ng-container>

                                        <!-- Manage Button Column -->
                                        <ng-container matColumnDef="manageBtn">
                                            <th mat-header-cell *matHeaderCellDef width="10%" class="table-cell"></th>
                                            <td mat-cell *matCellDef="let sub;" class="align-center table-cell">
                                                <button *ngIf="sub?.subscriptionDetailView"
                                                    class="button button-red button-round"
                                                    (click)="manageWGSubscription(sub?.subscriptionDetailView)">Manage
                                                </button>
                                                <mat-spinner *ngIf="!sub?.subscriptionDetailView" mode="indeterminate"
                                                    class="circle" style="margin: 15px auto;" diameter="20">
                                                </mat-spinner>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="['desc', 'status', 'manageBtn'] sticky:true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: ['desc', 'status', 'manageBtn'];"></tr>
                                    </table>


                                    <!-- table footer -->
                                    <!-- <div class="row totalPrice-wrapper">
                                        <div class="col align-center">
                                            <span><b>Active Total (Ex GST) </b>
                                                <span class="activeTotal">{{activeTotal |
                                                    currency:'AUD':'symbol-narrow':'.2-2'}}<span>/mth</span></span></span>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                          
                            <div>
                                <div class="col button-center">
                                    <label class="noData-label" *ngIf="!WGSHardwareSubs?.length">
                                        We couldn’t find any hardware subscriptions for this tenant
                                    </label>
                                    <br/>
                                    <button class="button button-red button-large button-center-left"
                                        (click)="getWGSProductList();">Add new product</button>
                                </div>
                            </div>
                        </mat-expansion-panel>
                        <!-- ELECTRONIC SUBSCRIPTIONS -->
                        <mat-expansion-panel [expanded]="!isWGSItemLoading">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="highlight-text"> ELECTRONIC SUBSCRIPTIONS </mat-panel-title>
                                <mat-panel-description class="panel-subtitle">
                                    <span class="highlight-text"> {{ WGSElectronicSubs?.length ?
                                        WGSElectronicSubs.length : "0" }} Subscription(s) </span>
                                    <mat-spinner *ngIf="isWGSItemLoading" mode="indeterminate"
                                        class="circle cSPCustomerEntitlements-loading" diameter="20">
                                    </mat-spinner>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="searchInputGroup push-left" style="margin-left: 5px">
                                <div class="searchIcon">
                                    <img src="../../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter"
                                    onfocus="this.placeholder=''" onblur="this.placeholder='Filter'"
                                    [(ngModel)]="WGSElectronicSubSearchField" (ngModelChange)="filterWGSElectronicSubs()">
                            </div>
                            <div class="mTable">
                                <div *ngIf="WGSElectronicSubs?.length">
                                    <table class="table" mat-table [dataSource]="WGSElectronicSubs" style="margin-bottom: unset;">
                                        <!-- Desc Column -->
                                        <ng-container matColumnDef="desc">
                                            <th mat-header-cell *matHeaderCellDef width="50%" class="table-cell" style="text-align: left;">
                                                SUBSCRIPTION </th>
                                            <td class="push-left-75 table-cell" mat-cell *matCellDef="let sub">
                                                <span>PART CODE:&nbsp;</span>
                                                <span class="red-bold">{{ sub?.subscriptionListView?.out_stock_code}}</span>

                                                <div class="result-info">
                                                    <div class="produc-secondary-title-wrapper">
                                                        <span class="description">{{sub?.subscriptionListView?.out_stk_description}}</span>
                                                        <div class="result-info">
                                                            <span>SUBSCRIPTION ID:&nbsp;</span>
                                                            <span class="red-bold">{{sub?.subscriptionListView?.out_subscription_id}}&nbsp;&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>

                                        <!-- QTY Column -->
                                        <ng-container matColumnDef="userCount">
                                            <th mat-header-cell *matHeaderCellDef class="align-center table-cell"
                                                width="15%"> QTY </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-center align-top table-cell">
                                                <span *ngIf="sub?.subscriptionDetailView"> {{
                                                    sub?.subscriptionDetailView?.userCount }} </span>
                                            </td>
                                        </ng-container>

                                        <!-- Status Column -->
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef class="align-center table-cell"
                                                width="15%"> STATUS </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-center align-top table-cell">
                                                <span *ngIf="sub?.subscriptionDetailView"> {{
                                                    sub?.subscriptionDetailView?.subscriptionStatus }} </span>
                                            </td>
                                        </ng-container>

                                        <!-- RRP Column -->
                                        <ng-container matColumnDef="rrp">
                                            <th
                                                *matHeaderCellDef
                                                mat-header-cell
                                                class="align-right table-cell"
                                                width="10%"
                                            >
                                                <span>RRP</span> 
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let sub;"
                                                class="align-right push-left-75 table-cell"
                                            >
                                                <span>{{ sub?.subscriptionListView?.out_rrp | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</span>
                                            </td>
                                        </ng-container>

                                        <!-- Price Column -->
                                        <ng-container matColumnDef="price">
                                            <th mat-header-cell *matHeaderCellDef class="align-right table-cell"
                                                width="10%"> PRICE </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-right push-left-75 table-cell">
                                                {{ sub?.subscriptionListView?.out_price |
                                                currency:'AUD':'symbol-narrow':'.2-2'}}
                                                <span>/mth</span>
                                            </td>
                                        </ng-container>

                                        <!-- Total Column -->
                                        <ng-container matColumnDef="total">
                                            <th mat-header-cell *matHeaderCellDef class="align-right table-cell"
                                                width="10%"> TOTAL </th>
                                            <td mat-cell *matCellDef="let sub;"
                                                class="align-right push-left-75 table-cell">
                                                {{ sub?.subscriptionListView?.out_amount |
                                                currency:'AUD':'symbol-narrow':'.2-2'}}
                                                <span>/mth</span>
                                            </td>
                                        </ng-container>

                                        <!-- Manage Button Column -->
                                        <ng-container matColumnDef="manageBtn">
                                            <th mat-header-cell *matHeaderCellDef width="10%" class="table-cell"></th>
                                            <td mat-cell *matCellDef="let sub;" class="align-center table-cell">
                                                <mat-spinner *ngIf="!sub?.subscriptionDetailView" mode="indeterminate"
                                                    class="circle" style="margin: 15px auto;" diameter="20">
                                                </mat-spinner>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <!-- table footer -->
                                    <!-- <div class="row totalPrice-wrapper">
                                        <div class="col align-center">
                                            <span><b>Active Total (Ex GST) </b>
                                                <span class="activeTotal">{{activeTotal |
                                                    currency:'AUD':'symbol-narrow':'.2-2'}}<span>/mth</span></span></span>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <div *ngIf="programType == 'WGS'">
                                <div class="col button-center">
                                    <label class="noData-label" *ngIf="!WGSElectronicSubs?.length">
                                        We couldn’t find any electronicS subscriptions for this tenant
                                    </label>
                                    <br />
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                </ng-container>
                <ng-container *ngIf="hasEmptyFilterResult">
                    <div class="noResult-wrapper">
                        <div><img src="../images/new_ui/no-found.png"></div>
                        <div>No results found</div>
                        <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
                        <div>
                            <button (click)="filterReset()" class="button button-red button-large">Try again</button>
                        </div>
                        <div class="noResult-feedback">Send Feedback</div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="blockContainer narrow-sidebar narrow-sidebar-overflow" id="levelTwo" *ngIf="narrowMode">
        <div class="combination-loader" style="display: flex; width: 100%;">
            <div class="child-sidebar" style="border-right: 1px solid #dee2e6;" *ngIf="!hideSideBar && programType!=='WGS'">
                <child-header *ngIf="programType ==='CSP'" [buttonCollapse]="true" [showDownload]="true"
                    tooltipDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()" [showAddUser]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                    tooltipAddUser="Create New End User" (addUserEvent)="addNewEndUser()" [showAssociate]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                    tooltipAssociate="Associate Existing End User" (associateEvent)="associateExistingEndUser()"
                    [title]="programName" (closeEvent)="close()"></child-header>
                <child-header *ngIf="programType ==='KASP'" [buttonCollapse]="true" [showDownload]="true"
                    tooltipDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()" [showAddUser]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                    tooltipAddUser="Create New End User" (addUserEvent)="addKaspNewEndUser()" [title]="programName"
                    (closeEvent)="close()"></child-header>
                <child-header *ngIf="programType ==='VDC'" [buttonCollapse]="true" [showDownload]="true"
                    tooltipDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()" [showAddUser]="true"
                    tooltipAddUser="Create New End User" (addUserEvent)="addCirrusNewEndUser()" [title]="programName"
                    (closeEvent)="close()"></child-header>
                <child-header *ngIf="programType ==='AMP'" [showDownload]="false"
                    titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()" [title]="programName"
                    (closeEvent)="close()"></child-header>
                <child-header *ngIf="!['CSP', 'KASP', 'VDC', 'AMP'].includes(programType)" [showDownload]="true"
                    titleDownload="Download Excel" (downloadEvent)="exportExcelForAnnuities()" [title]="programName"
                    (closeEvent)="close()"></child-header>
                    
                <div class="child-body child-body-narrowMode">
                    <div class="searchInputGroup">
                        <div class="searchIcon search-carts">
                            <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput searchInputGroup-small" type="text" placeholder="Filter"
                            onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField"
                            (ngModelChange)="onChange()">
                    </div>
                    <ng-container *ngFor="let item of sortedData | TableFilter: ['endUserName', 'annuityId'] : searchField">
                        <div class="menu-wrapper menu-wrapper-position" [class.active]="isActive(item?.annuityId)"
                            (click)="manageRedirect(item, model.detailsView)">
                            <div class="total-div">
                                <div class="narrow-title">{{item?.endUserName}}</div>
                                <div *ngIf="programType == 'CSP'" class="row" style="width: 141%;">
                                    <div *ngIf="item?.autoRenew != 'NO'" class="col" style="padding-right: unset;">
                                        <span  class="narrow-text" style="color: #C20047">Auto-Renew:&nbsp;</span>
                                        <img *ngIf="item?.autoRenew == 'YES'" src="../../images/site-icons/yes.svg" style="width: 14px; height: 14px; margin-bottom: 3px;">
                                        <span class="narrow-text" *ngIf="item?.autoRenew != 'YES' && item?.autoRenew != 'NO'">
                                            {{item?.autoRenew}} 
                                        </span>
                                    </div>
                                    <div *ngIf="item?.euPortalAccess" class="col" style="padding-right: unset;">
                                        <span  class="narrow-text" style="color: #C20047">EU Portal:&nbsp;</span>
                                        <img src="../../images/site-icons/yes.svg" style="width: 14px; height: 14px; margin-bottom: 3px;">
                                    </div>
                                </div>
                                <span *ngIf="programType != 'CSP'" class="narrow-text">{{item?.status}} |
                                    Amount:
                                    {{item?.totalAmount | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                            </div>
                            <div class="icon">
                                <span class="basic-icon information-icon information-icon-position"></span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="child-loader" *ngIf="showRest">
                <router-outlet></router-outlet>
            </div>
            <ng-template #dynamicInsert></ng-template>
        </div>
    </div>
</div>
